import { CommonModule, DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { ReservationModel } from 'src/app/models/reservation.model';
import { DocumentTypeLabelPipe } from 'src/app/shared/pipes/enum-label.pipe';
import { DescriptionService } from 'src/app/shared/services/description.service';

@Component({
  selector: 'app-reservation-table',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    DatePipe,
    DocumentTypeLabelPipe
  ],
  templateUrl: './reservation-table.component.html',
  styleUrl: './reservation-table.component.css'
})

export class ReservationTableComponent {
  @Input() dataSource!: MatTableDataSource<ReservationModel>;
  @Input() displayedColumns!: string[];
  @Input() totalCount = 0;
  @Input() pageSize = 10;
  @Input() pageIndex = 0;
  @Input() isLoading = false;
  @Input() errorClassFn!: (row: ReservationModel) => string;
  @Input() canCheckInFn!: (reservation: ReservationModel) => boolean;
  @Input() canCheckOutFn!: (reservation: ReservationModel) => boolean;
  @Input() canCancelFn!: (reservation: ReservationModel) => boolean;
  @Input() canEditFn!: (reservation: ReservationModel) => boolean;
  @Input() canRegisterPaymentFn!: (reservation: ReservationModel) => boolean;

  @Output() pageChange = new EventEmitter<PageEvent>();
  @Output() actionClick = new EventEmitter<{ action: string, reservation: ReservationModel }>();

  constructor(public descriptionService: DescriptionService) { }

  onPageChange(event: PageEvent) {
    this.pageChange.emit(event);
  }

  emitAction(action: string, reservation: ReservationModel) {
    this.actionClick.emit({ action, reservation });
  }
}
